// extracted by mini-css-extract-plugin
module.exports = {"title":"Code_title__3PPuc","code":"Code_code__Sl3lc"};